import React from 'react';
import AnalyticsIcon from './icons/icon_analytics.svg';
import CandidatesIcon from './icons/icon_candidates.svg';
import DocumentationIcon from './icons/icon_documentation.svg';
import GettingStartedIcon from './icons/icon_getting_started.svg';
import HelpIcon from './icons/icon_help.svg';
import JobsIcon from './icons/icon_jobs.svg';
import ProfileIcon from './icons/icon_profile.svg';
import SettingsIcon from './icons/icon_settings.svg';
import { ACCOUNT_ADMIN_PERMISSIONS, ADMIN_PERMISSIONS, isAuthorized, REVIEWER_PERMISSIONS, SUPPORT_ADMIN_PERMISSIONS } from 'security/authorization';
export const filterItems = (user, items) => {
    return items.filter((item) => {
        const itemCopy = item;
        if (item.subItems) {
            itemCopy.subItems = item.subItems.filter((subItem) => {
                return isAuthorized(user, subItem.permissions);
            });
        }
        return isAuthorized(user, itemCopy.permissions);
    });
};
export const getMenuItemsTop = (hasAnalyticsAccess) => {
    return [
        {
            name: 'candidates',
            label: 'Candidates',
            url: '/account/candidates',
            icon: React.createElement(CandidatesIcon, null),
            description: 'Invite customers to verify their ID from the Candidates page. You can also view a list of pending candidates.',
            permissions: REVIEWER_PERMISSIONS
        },
        {
            name: 'jobs',
            label: 'Jobs',
            url: '/account/jobs',
            icon: React.createElement(JobsIcon, null),
            description: "View a list of your account's jobs and their statuses and details on the Jobs page.",
            permissions: REVIEWER_PERMISSIONS
        },
        ...(hasAnalyticsAccess
            ? [
                {
                    name: 'analytics',
                    label: 'Analytics',
                    url: '/account/analytics',
                    icon: React.createElement(AnalyticsIcon, null),
                    description: "View analytics of your account's jobs.",
                    permissions: REVIEWER_PERMISSIONS
                }
            ]
            : []),
        {
            name: 'settings',
            label: 'Settings',
            icon: React.createElement(SettingsIcon, null),
            description: 
            // eslint-disable-next-line max-len
            'Settings contains the pages Users, Groups, Keys, and Billing. Invite users to your account in Users and create and manage groups in Groups. Generate API keys with the Keys page and view your subscription details in Billing.',
            permissions: ACCOUNT_ADMIN_PERMISSIONS,
            subItems: [
                {
                    name: 'company-users',
                    label: 'Users',
                    url: '/account/users',
                    permissions: ACCOUNT_ADMIN_PERMISSIONS
                },
                {
                    name: 'saml-security',
                    label: 'SAML Security',
                    url: '/account/saml-security',
                    permissions: ACCOUNT_ADMIN_PERMISSIONS
                },
                {
                    name: 'company-groups',
                    label: 'Groups',
                    url: '/account/groups',
                    permissions: ACCOUNT_ADMIN_PERMISSIONS
                },
                {
                    name: 'company-key',
                    label: 'Keys',
                    url: '/account/key',
                    permissions: ACCOUNT_ADMIN_PERMISSIONS
                },
                {
                    name: 'billing-payments',
                    label: 'Billing',
                    url: '/account/billing-payments',
                    permissions: ACCOUNT_ADMIN_PERMISSIONS
                }
            ]
        },
        {
            name: 'admin',
            label: 'Administrator',
            icon: React.createElement(ProfileIcon, null),
            description: 'Manage all jobs, accounts and users as an Administrator.',
            permissions: SUPPORT_ADMIN_PERMISSIONS,
            subItems: [
                {
                    name: 'admin-jobs',
                    label: 'All Jobs',
                    url: '/admin/jobs',
                    permissions: SUPPORT_ADMIN_PERMISSIONS
                },
                {
                    name: 'account-manager',
                    label: 'Account Manager',
                    url: '/admin/accounts',
                    permissions: SUPPORT_ADMIN_PERMISSIONS
                },
                {
                    name: 'user-manager',
                    label: 'User Manager',
                    url: '/admin/users',
                    permissions: SUPPORT_ADMIN_PERMISSIONS
                },
                {
                    name: 'template-manager',
                    label: 'Template Manager',
                    url: '/admin/templates',
                    permissions: ADMIN_PERMISSIONS
                },
                {
                    name: 'usage-reports',
                    label: 'Usage Reports',
                    url: '/admin/usage-reports',
                    permissions: SUPPORT_ADMIN_PERMISSIONS
                }
            ]
        }
    ];
};
export const menuItemsBottom = [
    {
        name: 'get-started',
        label: 'Get Started',
        url: '/account/get-started',
        icon: React.createElement(GettingStartedIcon, null),
        permissions: ACCOUNT_ADMIN_PERMISSIONS
    },
    {
        name: 'documentation',
        label: 'Documentation',
        url: 'https://docs.vouched.id/docs',
        icon: React.createElement(DocumentationIcon, null),
        permissions: REVIEWER_PERMISSIONS
    },
    {
        name: 'help',
        label: 'Help',
        url: 'https://www.vouched.id/for-developers/support/',
        icon: React.createElement(HelpIcon, null),
        permissions: REVIEWER_PERMISSIONS
    }
];
